import Link from 'next/link';
import styled from 'styled-components';
import moment from 'moment';
import { News } from '../../../pages/news';

export default function NewsSection({ highlightNews }: { highlightNews: News[] }) {
  return (
    <Container>
      <Wrapper>
        <TitleWrapper>
          <FakeTitle>언론 속 청연</FakeTitle>
          <TitleDesktop>{TitleDesktopSvg}</TitleDesktop>
          <TitleTablet>{TitleTabletSvg}</TitleTablet>
        </TitleWrapper>
        <NewsList>
          {highlightNews.slice(0, 3).map((news, index) => (
            <NewsWrapper key={index}>
              <Link href={news.url} passHref>
                <NewsAnchor target="_blank">
                  <NewsTitle>{news.title}</NewsTitle>
                </NewsAnchor>
              </Link>
              <NewsSub>
                <NewsPress>{news.press}</NewsPress>
                <NewsPublisehdAt>{moment(news.published_at).format('YYYY-MM-DD')}</NewsPublisehdAt>
              </NewsSub>
            </NewsWrapper>
          ))}
        </NewsList>
        <Link href="/news" passHref>
          <ViewMore>
            기사 더보기<CircleArrowRight>{CircleArrowRightSvg}</CircleArrowRight>
          </ViewMore>
        </Link>
      </Wrapper>
    </Container>
  );
}

const Container = styled.section`
  width: 100%;
  padding: 0 24px;
  padding-top: 108px;
  padding-bottom: 144px;
  position: relative;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding-top: 66px;
    padding-bottom: 80px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding-top: 76px;
    padding-bottom: 77px;
  }
`;

const Wrapper = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    /* max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.mobile}; */
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  justify-content: flex-start;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    margin-bottom: 20px;
    justify-content: center;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 30px;
    justify-content: flex-start;
  }
`;

const FakeTitle = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const TitleDesktop = styled.div`
  display: block;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: none;
  }
`;

const TitleTablet = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: block;
  }
`;

const NewsList = styled.div`
  margin-bottom: 30px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 20px;
  }
`;

const NewsWrapper = styled.article`
  padding: 44px 0 40px 0;
  border-bottom: 1px solid #e5e5e5;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding: 30px 0;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding: 30px 0;
  }
`;

const NewsTitle = styled.h2`
  font-weight: 500;
  font-size: 25px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 21px;
  }

  display: inline;
  background-image: linear-gradient(90deg, #000000, #000000);
  background-size: 0% 1.5px;
  background-repeat: no-repeat;
  background-position: left bottom;
  transition: 0.3s ease;
`;

const NewsAnchor = styled.a`
  display: block;
  margin-bottom: 12px;

  &:hover ${NewsTitle} {
    background-size: 100% 1.5px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 14px;
  }
`;

const NewsSub = styled.div`
  display: flex;
  flex-direction: row;
`;

const NewsPress = styled.h3`
  font-weight: 500;
  font-size: 19px;
  line-height: 140%;
  color: #239eb1;
  margin-right: 8px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 16px;
  }
`;

const NewsPublisehdAt = styled.time`
  font-weight: 300;
  font-size: 19px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.4);

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 17px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 16px;
    font-weight: 400;
  }
`;

const CircleArrowRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  transition: 0.2s;
`;

const ViewMore = styled.a`
  font-weight: 600;
  font-size: 17px;
  line-height: 140%;
  display: flex;
  width: fit-content;
  justify-content: flex-start;
  align-items: center;

  ${CircleArrowRight} {
    transform: none;
  }

  &:hover {
    /* text-decoration: underline; */

    ${CircleArrowRight} {
      transform: translateX(6px);

      svg circle {
        fill: #262626;
      }

      svg path {
        stroke: #ffffff;
      }
    }
  }
`;

const TitleDesktopSvg = (
  <svg width="214" height="45" viewBox="0 0 214 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.86789 13.586C5.86789 10.09 8.39789 7.514 11.9399 7.514C15.4819 7.514 18.1499 10.09 18.1499 13.586C18.1499 17.036 15.4819 19.75 11.9399 19.75C8.39789 19.75 5.86789 17.036 5.86789 13.586ZM36.2279 42.934V38.518H15.5279V27.892H10.4219V42.934H36.2279ZM0.807891 13.586C0.807891 19.658 5.49989 24.166 11.9399 24.166C16.9079 24.166 20.7719 21.636 22.3819 17.818C22.7039 17.128 22.9339 16.346 23.0719 15.564H30.5699V30.928H35.7219V0.705998H30.5699V11.286H22.9799C22.8419 10.688 22.6579 10.044 22.3819 9.446C20.7259 5.582 16.9079 3.006 11.9399 3.006C5.49989 3.006 0.807891 7.652 0.807891 13.586ZM47.0803 32.492V43.716H74.0363V39.392H52.2323V32.492H47.0803ZM57.6603 21.222V25.132H40.7783V29.548H79.5103V25.132H62.6743V21.222H73.8063V16.944H52.2323V13.448H72.8403V1.58H47.1263V5.812H67.7343V9.216H47.1263V21.222H57.6603ZM114.513 44.452V29.548H88.0167V33.918H109.361V44.452H114.513ZM98.5967 0.889999V3.006C98.5967 8.618 92.2487 12.804 85.6247 13.816L87.6487 18.002C94.0887 16.944 99.3327 13.678 101.541 9.308C103.749 13.678 108.993 16.944 115.433 18.002L117.457 13.816C110.741 12.804 104.439 8.618 104.439 3.006V0.889999H98.5967ZM120.907 26.282V21.958H104.071V16.208H99.0567V21.958H82.1747V26.282H120.907ZM155.048 5.214V0.843999H141.892V5.214H155.048ZM166.134 35.804C166.134 38.748 163.558 40.588 159.74 40.588C156.06 40.588 153.438 38.748 153.438 35.804C153.438 32.86 156.06 31.02 159.74 31.02C163.558 31.02 166.134 32.86 166.134 35.804ZM171.838 26.144V0.614H166.732V13.862H159.464V18.14H166.732V26.144H171.838ZM145.71 12.206C145.618 13.31 145.388 14.276 144.974 15.15C143.41 18.692 139.868 20.808 135.912 22.326L138.304 26.374C142.858 25.04 147.182 21.36 148.608 18.048C150.08 21.314 154.726 24.304 158.774 25.546L160.982 21.406C156.888 20.302 153.484 18.14 152.104 14.874C151.782 14.092 151.552 13.172 151.46 12.206H159.786V7.882H137.108V12.206H145.71ZM171.286 35.804C171.286 30.514 166.502 26.696 159.74 26.696C153.116 26.696 148.286 30.514 148.286 35.804C148.286 41.186 153.116 44.958 159.74 44.958C166.502 44.958 171.286 41.186 171.286 35.804ZM208.082 6.502H197.318C195.294 4.386 192.35 3.052 188.9 3.052C182.368 3.052 177.676 7.698 177.676 13.632C177.676 19.704 182.368 24.212 188.9 24.212C192.58 24.212 195.708 22.786 197.686 20.394H208.082V30.284H213.234V0.705998H208.082V6.502ZM213.832 42.934V38.518H193.04V27.8H187.934V42.934H213.832ZM195.064 13.586C195.064 17.082 192.396 19.796 188.9 19.796C185.312 19.796 182.736 17.082 182.736 13.586C182.736 10.09 185.312 7.514 188.9 7.514C192.396 7.514 195.064 10.09 195.064 13.586ZM200.124 13.632C200.124 12.758 199.986 11.838 199.802 11.01H208.082V15.978H199.894C200.032 15.242 200.124 14.46 200.124 13.632Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const TitleTabletSvg = (
  <svg width="129" height="27" viewBox="0 0 129 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.63588 8.257C3.63588 6.205 5.12088 4.693 7.19988 4.693C9.27888 4.693 10.8449 6.205 10.8449 8.257C10.8449 10.282 9.27888 11.875 7.19988 11.875C5.12088 11.875 3.63588 10.282 3.63588 8.257ZM21.4559 25.483V22.891H9.30588V16.654H6.30888V25.483H21.4559ZM0.665879 8.257C0.665879 11.821 3.41988 14.467 7.19988 14.467C10.1159 14.467 12.3839 12.982 13.3289 10.741C13.5179 10.336 13.6529 9.877 13.7339 9.418H18.1349V18.436H21.1589V0.696999H18.1349V6.907H13.6799C13.5989 6.556 13.4909 6.178 13.3289 5.827C12.3569 3.559 10.1159 2.047 7.19988 2.047C3.41988 2.047 0.665879 4.774 0.665879 8.257ZM28.3658 19.354V25.942H44.1878V23.404H31.3898V19.354H28.3658ZM34.5758 12.739V15.034H24.6668V17.626H47.4008V15.034H37.5188V12.739H44.0528V10.228H31.3898V8.176H43.4858V1.21H28.3928V3.694H40.4888V5.692H28.3928V12.739H34.5758ZM68.4857 26.374V17.626H52.9337V20.191H65.4617V26.374H68.4857ZM59.1437 0.804999V2.047C59.1437 5.341 55.4177 7.798 51.5297 8.392L52.7177 10.849C56.4977 10.228 59.5757 8.311 60.8717 5.746C62.1677 8.311 65.2457 10.228 69.0257 10.849L70.2137 8.392C66.2717 7.798 62.5727 5.341 62.5727 2.047V0.804999H59.1437ZM72.2387 15.709V13.171H62.3567V9.796H59.4137V13.171H49.5047V15.709H72.2387ZM93.3579 3.343V0.778H85.6359V3.343H93.3579ZM99.8649 21.298C99.8649 23.026 98.3529 24.106 96.1119 24.106C93.9519 24.106 92.4129 23.026 92.4129 21.298C92.4129 19.57 93.9519 18.49 96.1119 18.49C98.3529 18.49 99.8649 19.57 99.8649 21.298ZM103.213 15.628V0.643H100.216V8.419H95.9499V10.93H100.216V15.628H103.213ZM87.8769 7.447C87.8229 8.095 87.6879 8.662 87.4449 9.175C86.5269 11.254 84.4479 12.496 82.1259 13.387L83.5299 15.763C86.2029 14.98 88.7409 12.82 89.5779 10.876C90.4419 12.793 93.1689 14.548 95.5449 15.277L96.8409 12.847C94.4379 12.199 92.4399 10.93 91.6299 9.013C91.4409 8.554 91.3059 8.014 91.2519 7.447H96.1389V4.909H82.8279V7.447H87.8769ZM102.889 21.298C102.889 18.193 100.081 15.952 96.1119 15.952C92.2239 15.952 89.3889 18.193 89.3889 21.298C89.3889 24.457 92.2239 26.671 96.1119 26.671C100.081 26.671 102.889 24.457 102.889 21.298ZM125.027 4.099H118.709C117.521 2.857 115.793 2.074 113.768 2.074C109.934 2.074 107.18 4.801 107.18 8.284C107.18 11.848 109.934 14.494 113.768 14.494C115.928 14.494 117.764 13.657 118.925 12.253H125.027V18.058H128.051V0.696999H125.027V4.099ZM128.402 25.483V22.891H116.198V16.6H113.201V25.483H128.402ZM117.386 8.257C117.386 10.309 115.82 11.902 113.768 11.902C111.662 11.902 110.15 10.309 110.15 8.257C110.15 6.205 111.662 4.693 113.768 4.693C115.82 4.693 117.386 6.205 117.386 8.257ZM120.356 8.284C120.356 7.771 120.275 7.231 120.167 6.745H125.027V9.661H120.221C120.302 9.229 120.356 8.77 120.356 8.284Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const CircleArrowRightSvg = (
  <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="11.0483" cy="11" r="10.5" stroke="#262626" />
    <path
      d="M12.2559 6.63867L16.3991 10.9788L12.2191 15.3575"
      stroke="black"
      strokeWidth="1.54323"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M15.5963 11.0742L5.69629 11.0742" stroke="black" strokeWidth="1.54323" strokeLinecap="round" />
  </svg>
);
